import {GetConciergeUrlParams} from 'domain/usecases/private/home/concierge';
import {makeGetConciergeUrl} from 'main/factories/usecases/private/remote-home/get-concierge-url-factory';

export const getConciergeUrl = async (params: GetConciergeUrlParams) => {
	const response = await makeGetConciergeUrl().get(params);

	const url = response?.content?.[0]?.url ?? '';

	return url;
};
